export default "__VITE_ASSET__eb86af7e__"